import React from 'react';

const Banner = () => {
	return (
		<div className="banner d-flex justify-content-center align-items-center">
			<div className="banner-info d-flex justify-content-center">
				<div className="headline">
					<h1>I Grow By Helping People In Need</h1>
					<input className="form-control" type="text" />
					<button style={{ padding: '10px 60px', margin: '10px 0' }} className="btn btn-primary">
						Search
					</button>
				</div>
			</div>
		</div>
	);
};

export default Banner;
